export var ToasterCssClass;
(function (ToasterCssClass) {
    ToasterCssClass["Base"] = "iress-toaster";
    ToasterCssClass["Wrapper"] = "iress-toaster__wrapper";
})(ToasterCssClass || (ToasterCssClass = {}));
export var NewToast;
(function (NewToast) {
    NewToast["Tag"] = "iress-toast";
    NewToast["StatusAttr"] = "status";
    NewToast["HeadingLevelAttr"] = "heading-level";
    NewToast["HeadingTextAttr"] = "heading-text";
    NewToast["DataTestIdAttr"] = "data-testid";
    NewToast["TimeoutAttr"] = "timeout";
    NewToast["DismissableAttr"] = "dismissible";
})(NewToast || (NewToast = {}));
export var ToasterPosition;
(function (ToasterPosition) {
    ToasterPosition["BottomStart"] = "bottom-start";
    ToasterPosition["BottomCenter"] = "bottom-center";
    ToasterPosition["BottomEnd"] = "bottom-end";
    ToasterPosition["TopStart"] = "top-start";
    ToasterPosition["TopCenter"] = "top-center";
    ToasterPosition["TopEnd"] = "top-end";
})(ToasterPosition || (ToasterPosition = {}));
//# sourceMappingURL=toaster.types.js.map